import { render } from "./dvcprintcommission.vue?vue&type=template&id=555cf088"
import script from "./dvcprintcommission.vue?vue&type=script&lang=js"
export * from "./dvcprintcommission.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__